import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root'
// })
export class AssetsService {

  /* IMAGENES */
  public static URL_IMAGEN_USER_MENU = 'https://firebasestorage.googleapis.com/v0/b/men-acvis.appspot.com/o/imagenes%2FEnmascarar%20grupo%203.jpg?alt=media&token=4e7f31bf-cfd6-49a4-99c6-19f9740e6808';

  /* ICONOS */
  public static URL_ICONO_DEMO_JPG = 'https://accesovisitantesuaccert.mineducacion.gov.co/acvis-web/assets/img/logo_men.png';
  public static URL_ICONO_DEMO_BLACK_PNG = 'https://accesovisitantesuaccert.mineducacion.gov.co/acvis-web/assets/img/logo_men.png';
  public static URL_ICONO_DEMO_PINK_PNG = 'https://accesovisitantesuaccert.mineducacion.gov.co/acvis-web/assets/img/logo_men.png';
  public static URL_ICONO_DEMO_GRAY_PNG = 'https://accesovisitantesuaccert.mineducacion.gov.co/acvis-web/assets/img/logo_men.png';

  /* CONSTANTES */

  public static HORAS_DIA = ['06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30',
    '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00',
    '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30',
    '17:00', '17:30', '18:00'];

  public static MESES = new Array('ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO',
    'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE');
  public static DIAS_SEMANA = new Array('Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado');

}
